const TOKEN_KEY = 'token';
const TOKEN_EXPIRY_KEY = 'tokenExpiresAt';
const TOKEN_TTL_MS =30* 60 * 1000; // 2 minutes

let expiryTimeoutId = null;

const isBrowser = () => typeof window !== 'undefined' && typeof localStorage !== 'undefined';

const dispatchTokenChange = () => {
  if (!isBrowser()) return;
  window.dispatchEvent(new Event('localStorageChange'));
};

export const clearToken = () => {
  if (!isBrowser()) return;
  if (expiryTimeoutId) {
    clearTimeout(expiryTimeoutId);
    expiryTimeoutId = null;
  }
  localStorage.clear();
  dispatchTokenChange();
};

const scheduleExpiryRemoval = () => {
  if (!isBrowser()) return;

  if (expiryTimeoutId) {
    clearTimeout(expiryTimeoutId);
    expiryTimeoutId = null;
  }

  const token = localStorage.getItem(TOKEN_KEY);
  const expiresAtRaw = localStorage.getItem(TOKEN_EXPIRY_KEY);
  const expiresAt = expiresAtRaw ? parseInt(expiresAtRaw, 10) : null;

  if (!token || !expiresAt) {
    return;
  }

  const delay = expiresAt - Date.now();

  if (delay <= 0) {
    clearToken();
    return;
  }

  expiryTimeoutId = window.setTimeout(() => {
    clearToken();
  }, delay);
};

export const setTokenWithExpiry = (token) => {
  if (!isBrowser()) return;
  const expiresAt = Date.now() + TOKEN_TTL_MS;
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(TOKEN_EXPIRY_KEY, String(expiresAt));
  dispatchTokenChange();
  scheduleExpiryRemoval();
};

export const getValidToken = () => {
  if (!isBrowser()) return null;
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;

  const expiresAtRaw = localStorage.getItem(TOKEN_EXPIRY_KEY);
  const expiresAt = expiresAtRaw ? parseInt(expiresAtRaw, 10) : null;

  if (!expiresAt || Date.now() > expiresAt) {
    clearToken();
    return null;
  }

  return token;
};

export const initTokenExpiryWatcher = () => {
  if (!isBrowser()) return () => {};

  const handleStorageChange = (event) => {
    if (
      !event ||
      event.type === 'localStorageChange' ||
      event.key === null ||
      event.key === TOKEN_KEY ||
      event.key === TOKEN_EXPIRY_KEY
    ) {
      scheduleExpiryRemoval();
    }
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener('localStorageChange', handleStorageChange);

  scheduleExpiryRemoval();

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('localStorageChange', handleStorageChange);
    if (expiryTimeoutId) {
      clearTimeout(expiryTimeoutId);
      expiryTimeoutId = null;
    }
  };
};

export const TOKEN_TTL_MINUTES = TOKEN_TTL_MS / (60 * 1000);

